module.exports = __webpack_public_path__ + "static/img/aepic-27-2.c3f9263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-27-2.jpg
// module id = SGur
// module chunks = 51